var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.718506,
    width: 40,
    height: 40,
    rx: 8,
    fill: "#172154"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.7073 18.8829C35.0058 18.8829 35.4333 18.9572 35.6915 19.0534L35.9998 17.3386C35.5924 17.2684 35.1802 17.2329 34.7672 17.2324C32.7996 17.2324 31.8753 18.4569 31.8753 19.8311C31.8753 21.6309 33.6247 21.6096 33.6247 22.3763C33.6247 22.7599 33.3664 22.9728 32.8097 22.9728C32.4219 22.9728 31.8854 22.877 31.567 22.7492L31.2285 24.589C31.6911 24.6762 32.1603 24.7195 32.6303 24.7185C34.3902 24.7185 35.6218 23.4936 35.6218 22.013C35.6218 20.2666 33.8619 20.2348 33.8619 19.4677C33.8619 19.1274 34.0809 18.8822 34.7063 18.8822",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3841 22.8204L30.4255 17.236H28.6115L27.2388 24.6775L30.5463 24.6813L30.877 22.8204H29.3841Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8128 17.2377C23.1097 17.2377 21.3745 19.3538 21.3745 21.9507C21.3745 23.5754 22.1925 24.6976 24.257 24.6976C25.0747 24.6976 25.937 24.5402 26.6261 24.2302L27.2901 20.6363H25.4737L25.0845 22.8274C24.9209 22.8655 24.7536 22.8834 24.586 22.8805C23.6783 22.8805 23.3496 22.3572 23.3496 21.6624C23.3496 20.3692 24.1071 19.0336 25.6531 19.0336C26.1063 19.0393 26.5562 19.1144 26.9886 19.2565C27.0319 19.2696 27.0762 19.2841 27.1222 19.3004C27.2527 19.3453 27.3795 19.4012 27.5013 19.4677L27.8698 17.5236C27.1986 17.3373 26.5073 17.2412 25.8128 17.2377",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2293 17.2604L11.7437 19.7299H15.1017C12.3194 24.0395 6.79705 23.3075 5.33668 21.5208C4.07904 19.9822 5.16543 17.346 8.89233 15.7185C5.20333 16.8924 3.13242 19.9751 4.34911 22.0498C5.72825 24.4022 10.0278 25.3833 13.8495 24.2412C16.4033 23.3029 17.4934 21.9886 17.8918 21.2799L17.266 24.6973H19.7766L21.1384 17.2604H12.2293Z",
    fill: "#FCBF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGls);
export default __webpack_public_path__ + "static/media/gls.295e90daa6e3631da6453affdea89f8b.svg";
export { ForwardRef as ReactComponent };